<template>
  <div>
    <SignUpIdentificationDialog
      :closeAuth="closeAuth"
      :fromLogin="fromLogin"
      :identification="identification"
      :outsideClick="outsideClick"
      :show="activeComponent === $options.Steps.identification"
      :to="to"
      :updateIdentification="updateIdentification"
      :updatePhone="updatePhone"
    />
    <SignUpConfirmationDialog
      :closeAuth="closeAuth"
      :code="code"
      :fetchCart="fetchCart"
      :identification="identification"
      :outsideClick="outsideClick"
      :show="activeComponent === $options.Steps.confirmation"
      :to="to"
      :updateCode="updateCode"
    />
    <SignUpRegistrationDialog
      :closeAuth="closeAuth"
      :outsideClick="outsideClick"
      :registration="registration"
      :show="activeComponent === $options.Steps.registration"
      :signUp="signUp"
      :to="to"
      :updateRegistration="updateRegistration"
    />
  </div>
</template>

<script>
import { Steps } from "@/types/signup.js";
import { mapGetters, mapState } from "vuex";
import { formatPhoneNumber } from "@/util.js";
import SignUpConfirmationDialog from "@/components/Auth/SignUp/Dialogs/Confirmation.vue";
import SignUpIdentificationDialog from "@/components/Auth/SignUp/Dialogs/Identification.vue";
import SignUpRegistrationDialog from "@/components/Auth/SignUp/Dialogs/Registration.vue";

export default {
  name: "SignUp",
  components: {
    SignUpConfirmationDialog,
    SignUpIdentificationDialog,
    SignUpRegistrationDialog,
  },
  computed: {
    ...mapGetters({
      authorized: "auth/isAuthenticated",
      userClickedCartButtonBeforeAuthenticated:
        "cart/userClickedCartButtonBeforeAuthenticated",
    }),
    ...mapState({
      account: (state) => state.auth.account,
    }),
  },
  data() {
    return {
      activeComponent: null,
      code: { input0: null, input1: null, input2: null, input3: null },
      identification: { firstName: null, lastName: null, phone: null },
      registration: { confirmPassword: null, email: null, password: null },
    };
  },
  methods: {
    closeDialogAfterSignUp() {
      this.userClickedCartButtonBeforeAuthenticated &&
        this.$store.commit("cart/SET", true);
      this.closeAuth();
    },
    async fetchCart() {
      await this.$store.dispatch("cart/fetch");
      this.closeDialogAfterSignUp();
    },
    initActiveDialog() {
      this.activeComponent = this.account
        ? Steps.registration
        : Steps.identification;
    },
    async signUp() {
      const { input0, input1, input2, input3 } = this.code;
      const verificationCode =
        input1 !== null ? input0.concat(input1, input2, input3) : null;

      const info = {
        email: this.registration.email,
        password: this.registration.password,
      };

      /*
       * if NCM_ACCOUNT (account) then PUT /user,
       * otherwise (no account) POST /register
       */

      this.account
        ? this.$store.dispatch("auth/updateAndAuthenticateUser", info)
        : await this.$store.dispatch("auth/register", {
            ...info,
            country_code: 1,
            name: `${this.identification.firstName} ${this.identification.lastName}`,
            phone: this.identification.phone,
            verification_code: verificationCode,
          });
      this.authorized && this.fetchCart();
    },

    to(component) {
      this.activeComponent = component;
    },
    updateCode(input, val) {
      this.code[`input${input}`] = val;
    },
    updateIdentification(name, val) {
      this.identification[name] = val;
    },
    updatePhone(val) {
      this.identification.phone = formatPhoneNumber(val);
    },
    updateRegistration(name, val) {
      this.registration[name] = val;
    },
  },
  mounted() {
    this.$store.commit("auth/SHOW_SMS_RETRY_MESSAGE", false);
    this.initActiveDialog();
  },
  props: {
    closeAuth: Function,
    fromLogin: Boolean,
    outsideClick: Function,
  },
  Steps,
};
</script>
